module.exports = __webpack_public_path__ + "img/69.ce293551.png";